import Swal from "sweetalert2";

const AlertComponent = ({
  type,
  title,
  text,
  icon,
  onConfirm,
  onCancel,
  confirmButtonText,
  cancelButtonText,
  html,
}) => {
  let obj = {
    title,
    icon,
  };
  if (text) {
    obj.text = text;
  }
  if (html) {
    obj.html = html;
  }
  if (type === "confirm") {
    Swal.fire({
      ...obj,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: confirmButtonText || "Confirm",
      cancelButtonText: cancelButtonText || "Cancel",
    }).then((result) => {
      if (result.isConfirmed && onConfirm) {
        onConfirm(result);
      } else if (result.dismiss === Swal.DismissReason.cancel && onCancel) {
        onCancel(result);
      }
    });
 } else if(type === "warning"){
  Swal.fire({
    title: "Warning",
    text : "This account is already in use. You can either wait until the current session ends or choose to log in now.",
    showDenyButton: true,
    confirmButtonText: "Login now",
    confirmButtonColor: "#3085d6",
    denyButtonText: "Cancel Login",
    icon: "warning",
    customClass: {
      popup: "my-popup",
      title: "my-title", 
      content: "my-content", 
    },
  }).then((result) => {
    if (result.isConfirmed) {
      if (onConfirm) onConfirm();
    } else if (result.isDenied) {
      if (onCancel) onCancel();
    }
  });
  // .then((result) => {
  //   if (result.isConfirmed) {
  //     Swal.fire("Saved!", "", "success");
  //   } else if (result.isDenied) {
  //     Swal.fire("Changes are not saved", "", "info");
  //   }
  // });
 }
 else if(type === "failedsql"){
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text: "Something went wrong!",
  });

 }
  else if(type === "Success"){
    Swal.fire({
      icon: "success",
      title: "Mapper created succesfully",
    });
  }
  else {
    Swal.fire(obj).then((result) => {
      if (result.isConfirmed && onConfirm) {
        onConfirm(result);
      }
    });
  }
};

export default AlertComponent;
